import Auth0AB from 'auth0-ab';
import CookieMetrics from '@auth0/website-ab-cookie';

const abTesting = (experiments = []) => {
  try {
    const abTestingLib = new Auth0AB({
      experiments
    });

    abTestingLib.integration('auth0metrics').start({ metrics: window.metricsLib });
    abTestingLib.start().then(() => { enhanceAnalytics(abTestingLib.analytics); }).then(() => {
      try {
        window.abLoaded = true;
        // Save experiments on the global scope
        window.experiments = abTestingLib.getExperiments();
        executeABExperiments();
      } catch (e) {
        console.error('Error running AB experiments.');
        window.abLoaded = true;
      }
    });
  } catch (e) {
    console.error('Error initializing ABTesting lib. ABTesting will be disabled');
    window.abLoaded = true;
  }

  function enhanceAnalytics(analytics) {
    const cookieAnalytics = new CookieMetrics();

    const originalSetCurrentVariantName = analytics.setCurrentVariantName.bind(analytics);
    const originalGetCurrentVariantName = analytics.getCurrentVariantName.bind(analytics);

    const enhancedSetCurrentVariantName = function (variantName, value) {
      cookieAnalytics.setCurrentVariantName(variantName, value);
      originalSetCurrentVariantName(variantName, value);
    };

    const enhancedGetCurrentVariantName = function (variantName) {
      const originalValue = originalGetCurrentVariantName(variantName);
      const cookieValue = cookieAnalytics.getCurrentVariantName(variantName);

      if (originalValue !== cookieValue) {
        originalSetCurrentVariantName(variantName, cookieValue);
      }

      return cookieValue;
    };

    analytics.setCurrentVariantName = enhancedSetCurrentVariantName;
    analytics.getCurrentVariantName = enhancedGetCurrentVariantName;
    window.setVariant = enhancedSetCurrentVariantName;
    window.getVariant = enhancedGetCurrentVariantName;
  }

  function executeABExperiments() {
    const pathName = window.location.pathname;
    const Abexperiments = window.experiments;
    if (!window.abLoaded) {
      return;
    }
    if (!Abexperiments) {
      // Restore content
      return;
    }

    try {
      const experimentsForPath = Abexperiments.runAllByPath(pathName);
      let winningVariants = [];
      experimentsForPath.experiments.forEach((e) => {
        winningVariants = winningVariants.concat(e.getCurrentVariant().getPropertiesByType('js'));
      });
      const variantContext = {};
      variantContext.$ = $;
      winningVariants.forEach((v) => {
        v.runInContext(variantContext);
      });
    } catch (e) {
      console && console.error('Error running experiments for path:%s', pathName);
    }
  }
};

export default abTesting;
